import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  requestTemplate: {
    method: 'POST',
    url: `${configs.baseUrl}/api/hook/template/`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const requestTemplate = (payload) => {
  return resource.requestTemplate(payload)
}

export default {
  initResource,
  requestTemplate,
}
